export enum UserRoles {
  SuperAdmin = 'super-admin',
  Admin = 'admin',
}

export enum SpaceRoles {
  Editor = 'editor',
  SpaceOwner = 'space-owner',
  CertificateReviewer = 'certificate-reviewer',
  ContentReviewer = 'content-reviewer',
  ContentManager = 'content-manager',
}

export enum UserFeatures {
  /**
   * Allows access to A/B testing features
   */
  ABTestFeature = 'ab-test',

  /**
   * Allows viewing and managing certificates
   */
  CertificateReview = 'certificate-review',

  /**
   * Allows creating and editing content
   */
  ContentEditing = 'content-editing',

  /**
   * Allows reviewing and approving content changes
   */
  ContentReview = 'content-review',

  /**
   * Allows managing space settings and configurations
   */
  SpaceManagement = 'space-management',
}

export type UserClaims = {
  role?: UserRoles | null;
  coaches?: Record<string, { role?: SpaceRoles | null }>;
};

export type DTOPermissions = {
  role: UserRoles | SpaceRoles | null;
  features: UserFeatures[];
};
